var exports = {
  "Hc": "QuickCssEditorPanel.module__host___ZTNmbW",
  "Gt": "QuickCssEditorPanel.module__frame___ZTNmbW",
  "ko": "QuickCssEditorPanel.module__captureLayer___ZTNmbW",
  "Uv": "QuickCssEditorPanel.module__dockHandle___ZTNmbW",
};

module.exports = exports;
